import qs from 'qs';

export function normalizeLayerUrl(url: string) {
  if (!url) return url;
  // Il trim evita che spazi accidentali nell'URL configurato finiscano
  // percent-encoded nelle richieste (es. `/MapServer/4%20/query` → 404).
  const trimmed = url.trim();
  return trimmed.endsWith('/')
    ? trimmed.substring(0, trimmed.length - 1)
    : trimmed;
}

export function parseLayerAndOptions(rawUrl: string) {
  const [url, params] = rawUrl.split('?');
  const options = qs.parse(params, {
    allowPrototypes: false,
    ignoreQueryPrefix: true,
  });

  return {
    url: normalizeLayerUrl(url),
    options,
  };
}
